// extracted by mini-css-extract-plugin
export default {"senderMain":"PlainTextOfferMessage--senderMain--xZ1wropt","receiverMain":"PlainTextOfferMessage--receiverMain--DEDmnH0N","container":"PlainTextOfferMessage--container--TspH4fJT"};